const tableConfig = {
  addTooltip: 'Add',
  deleteTooltip: 'Delete',
  editTooltip: 'Edit',
  filterTooltip: 'filter',
  deleteText: 'Do you really want to delete this item?',
  cancelTooltip: 'Cancel',
  saveTooltip: 'Save',
  actions: 'Options',
  labelRowsSelect: 'items',
  firstTooltip: 'Start',
  previousTooltip: 'Previous',
  nextTooltip: 'Next',
  lastTooltip: 'Last',
  searchPlaceholder: 'Search...',
  labelDisplayedRows: 'in'
};

export default tableConfig;
